import Vue from "vue";
import { httpMgr } from "./network/httpMgr";
import { uiMgr } from "./uiMgr";
import { interfaceConfig } from "../constants/apiConstants";
import { storeMgr } from "./storeMgr";
import store from "../model/store/index";

// 卡券商城初始化配置接口
export interface MallInitConfig {
  router: any;
}

/**
 * 卡券商城初始化类
 * 只处理卡券商城独有的初始化逻辑
 */
export default class MallApplication {
  /**
   * 初始化卡券商城
   */
  init(config: MallInitConfig) {
    // 配置 Vue 忽略 quark- 开头的自定义元素（卡券商城使用的 Web Components）
    Vue.config.ignoredElements = [/^quark-/];

    // 初始化 Store 管理器
    storeMgr.init(store);

    // 初始化 HTTP 管理器
    httpMgr.init({
      interfaceConfig,
      uiMgr,
    });

    // 初始化 UI 管理器（页面跳转等）
    uiMgr.init({
      router: config.router,
    });
  }
}
